import { render, staticRenderFns } from "./AddPlant.vue?vue&type=template&id=22b5b388&"
import script from "./AddPlant.vue?vue&type=script&lang=js&"
export * from "./AddPlant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports